export const BILLING_DOCUMENT_STATE_SETTLED = 'settled';
export const BILLING_DOCUMENT_STATE_SENT = 'sent';
export const BILLING_DOCUMENT_STATE_NEW = 'new';
export const BILLING_DOCUMENT_STATE_ON_HOLD = 'onHold';
export const BILLING_DOCUMENT_STATE_PARTIALLY_PAID = 'partiallyPaid';
export const BILLING_DOCUMENT_STATE_VALIDATED = 'validated';
export const BILLING_DOCUMENT_STATUS_PROCESSING = -1;
export const BILLING_DOCUMENT_STATUS_NOT_PAID = 0;
export const BILLING_DOCUMENT_STATUS_PAID = 1;
export const BILLING_DOCUMENT_STATUS_PARTIALLY_PAID = 2;

export const BILLING_DOCUMENTS_STATE_TO_STATUS = {
  [BILLING_DOCUMENT_STATE_SETTLED]: BILLING_DOCUMENT_STATUS_PAID,
  [BILLING_DOCUMENT_STATE_SENT]: BILLING_DOCUMENT_STATUS_NOT_PAID,
  [BILLING_DOCUMENT_STATE_NEW]: BILLING_DOCUMENT_STATUS_NOT_PAID,
  [BILLING_DOCUMENT_STATE_ON_HOLD]: BILLING_DOCUMENT_STATUS_PROCESSING,
  [BILLING_DOCUMENT_STATE_PARTIALLY_PAID]: BILLING_DOCUMENT_STATUS_PARTIALLY_PAID,
  [BILLING_DOCUMENT_STATE_VALIDATED]: BILLING_DOCUMENT_STATUS_PROCESSING,
};

export const BILLING_DOCUMENT_ATTACHMENT_STATUS_GENERATED = 1;
export const BILLING_DOCUMENT_ATTACHMENT_STATUS_GENERATING = -1;
export const BILLING_DOCUMENT_ATTACHMENT_STATUS_NOT_GENERATED = 0;

export const BILLING_DOCUMENT_TYPE_FR = 'FR'; // Periodická faktúra
export const BILLING_DOCUMENT_TYPE_CI = 'CI'; // Predpis splatky
export const BILLING_DOCUMENT_TYPE_FC = 'FC'; // Dobropis
export const BILLING_DOCUMENT_TYPE_FG = 'FG'; // Faktúra tovar
export const BILLING_DOCUMENT_TYPE_C1 = 'C1'; // Upomienka
export const BILLING_DOCUMENT_TYPE_FP = 'FP'; // Terminačný dobropis
export const BILLING_DOCUMENT_TYPE_C5 = 'C5'; // Zmluvné pokuty
export const BILLING_DOCUMENT_TYPE_CS = 'CS'; // Obmedzenie služieb
export const BILLING_DOCUMENT_TYPE_C8 = 'C8'; // Prima Migrácia
export const BILLING_DOCUMENT_TYPE_FF = 'FF'; // Prvofaktúra
export const BILLING_DOCUMENT_TYPE_FH = 'FH'; // Dobropis tovar
export const BILLING_DOCUMENT_TYPE_FD = 'FD'; // Ťarchopis
export const BILLING_DOCUMENT_TYPE_FE = 'FE'; // Faktúra prepaid
export const BILLING_DOCUMENT_TYPE_FS = 'FS'; // Faktúra - int. zák.
export const BILLING_DOCUMENT_TYPE_F5 = 'F5';
export const BILLING_DOCUMENT_TYPE_F6 = 'F6';
export const BILLING_DOCUMENT_TYPE_F7 = 'F7';
export const BILLING_DOCUMENT_TYPE_FA = 'FA'; // Manuálna faktúra
export const BILLING_DOCUMENT_TYPE_FJ = 'FJ'; // Ťarchopis tovar
export const BILLING_DOCUMENT_TYPE_CR = 'CR'; // Zml. pokuta z RZ
export const BILLING_DOCUMENT_TYPE_FL = 'FL'; // Ťarchopis prepaid
export const BILLING_DOCUMENT_TYPE_FM = 'FM'; // Terminačný ťarchopis
export const BILLING_DOCUMENT_TYPE_FK = 'FK'; // Dobropis prepaid
export const BILLING_DOCUMENT_TYPE_FO = 'FO'; // Predbežná faktúra
export const BILLING_DOCUMENT_TYPE_FN = 'FN'; // Manuálna faktúra

export const DOCUMENT_TYPES_WITH_PENDING_STATE = [
  BILLING_DOCUMENT_TYPE_FR,
  BILLING_DOCUMENT_TYPE_FC,
  BILLING_DOCUMENT_TYPE_FG,
  BILLING_DOCUMENT_TYPE_FP,
  BILLING_DOCUMENT_TYPE_FF,
  BILLING_DOCUMENT_TYPE_FH,
  BILLING_DOCUMENT_TYPE_FD,
  BILLING_DOCUMENT_TYPE_FE,
  BILLING_DOCUMENT_TYPE_F5,
  BILLING_DOCUMENT_TYPE_F6,
  BILLING_DOCUMENT_TYPE_F7,
];

export const BILLING_DOCUMENT_MIME_TYPE_PDF = 'application/pdf';
export const BILLING_DOCUMENT_MIME_TYPE_HTML = 'text/html';

export const PUBLIC_TYPE_ID = 'PUBLIC';
export const ONLYSN_TYPE_ID = 'ONLYSN';
export const ONLYCN_TYPE_ID = 'ONLYCN';
export const DELAY_FOR_HTML_PDF_GENERATION = 5;
export const INV_MAIN_CONS = 'INV_MAIN-CONS';
export const ANNEX = 'ANNEX';
